"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNonEmptyArray = isNonEmptyArray;

/*
 * To use this type (e.g. pass an argument of NonEmptyArray, create a variable of that type),
 * you will have to use isNonEmptyArray to type narrow your array.
 *
 * const arr = ['m'];
 * const x: NonEmptyArray<string> = arr;    // TS error
 *
 * if (isNonEmptyArray(arr)) {
 *   const y: NonEmptyArray<string> = arr;  // all good!
 * } else {
 *   const z: NonEmptyArray<string> = arr;  // TS error
 * }
 *
 */
function isNonEmptyArray(obj) {
  return obj.length > 0;
}